// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"63":"sogamWrite","153":"sogamList","334":"judge","489":"xmasAdmin","588":"sogamSee","867":"adultRank","971":"pastorSogamList"}[chunkId] + "." + {"63":"d455cfbf","153":"a42a18b4","334":"d455cfbf","489":"087bb108","588":"d455cfbf","867":"34789371","971":"bb0568dc"}[chunkId] + ".css";
};